import { render, staticRenderFns } from "./archives.vue?vue&type=template&id=7e0ba13c&scoped=true&"
import script from "./archives.vue?vue&type=script&lang=js&"
export * from "./archives.vue?vue&type=script&lang=js&"
import style0 from "./archives.vue?vue&type=style&index=0&id=7e0ba13c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0ba13c",
  null
  
)

export default component.exports